var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('frequencyDistributionForMicrobe',{attrs:{"chartData":_vm.chartData,"title":"기회감염균"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }